import { IRange } from './area';

export interface IndexMapping {
  [key: string]: number;
}

export interface EntitySize extends IRange {
  size: number;
}

export enum GridEntity {
  Row = 'row',
  Column = 'column',
}
